import Circle from "../LogoSVG/Circle";
import teknikLogo from "../../public/teknikLogo.png";
import Arrow from "../LogoSVG/Arrow";

export const listTech = [
  "Web3 API",
  "Solidity",
  "Bep20 Network",
  "C#",
  "JavScript",
  "Metamask API",
];

function TeknikDesktop({ index, hoveredIndex, setHoveredIndex }: any) {
  return (
    <div
      className={`flex flex-row pt-8 ${
        hoveredIndex == undefined || hoveredIndex == index ? "" : "opacity-55"
      }`}
      onMouseEnter={() => setHoveredIndex(index)}
      onMouseLeave={() => setHoveredIndex(undefined)}
    >
      <a
        className="flex flex-col items-start "
        href="https://www.teknixcorp.com/"
        target="_blank"
      >
        <p className="w-[180px] items-start text-gray-4">Apr 2022 - Jul 2022</p>
        <div className="w-[90px] h-[90px] 2xl:h-[110px] 2xl:w-[110px] mt-3 ml-8 2xl:ml-8 overflow-hidden rounded-full">
          <img
            src={teknikLogo}
            alt="logo"
            className="object-cover w-full h-full"
          />
        </div>
      </a>

      <a
        className="pl-16 2xl:pl-24 w-[700px] 2xl:w-[740px] "
        href="https://www.teknixcorp.com/"
        target="_blank"
      >
        <div
          className="flex flex-row items-center mb-2 font-medium text-[18px]"
          style={{ color: hoveredIndex === index ? "#ebdd86" : "inherit" }}
        >
          <p className="">Software Developer Intern | TekNix Corporation</p>
          {/* <Circle className="mx-2 h-1.5 w-1.5 " />
          <p className="mr-4">TekNix Technology Corporation</p> */}
          <Arrow
            className={`transition-transform duration-250 ease-in-out mb-1 ml-2 ${
              hoveredIndex === index ? "-translate-y-2 translate-x-1" : ""
            }`}
          />
        </div>

        <div className="text-gray-5">
          <div className="flex flex-row mb-1.5">
            {/* <Circle className="mr-3 h-1.5 w-1.5 mt-2" /> */}
            <p className="text-gray-4 w-[550px]">
              Contributed to smart contract development and blockchain
              integration for game management, network interactions, and crypto
              wallet connectivity
            </p>
          </div>

          {/* <div className="flex flex-row mb-1.5 ">
            <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
            <p className="text-gray-4 w-[600px] ">
              Integrated blockchain functionalities into the game to interact with
              networks and crypto wallets
            </p>
          </div> */}
        </div>
      </a>
    </div>
  );
}

export default TeknikDesktop;
